import type { Database, DatabaseAction } from './types';

/** What the viewer may do with a database (the server enforces every action anyway). */
export function dbCan(
  database: Pick<Database, 'my_permissions'> | undefined,
  action: DatabaseAction,
) {
  return database?.my_permissions.includes(action) ?? false;
}

/** Full control of the database: the workspace owner or the database owner. */
export const isDatabaseOwner = (database: Pick<Database, 'my_role'> | undefined) =>
  database?.my_role === 'owner';
